import React from "react";
import { getFormattedDateAndTime } from "../../helper/utils";
type Props = {
  cell: any;
};
function TransactionsTableCreatedOn(props: Props) {
  const { cell } = props;
  return <>{getFormattedDateAndTime(cell.row.original.createdOn)}</>;
}

export default TransactionsTableCreatedOn;
